import { Button, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { facultyOptions } from '@/module/Nomen/Faculty/model/FacultyModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type FacultySelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function FacultySelectControl<T extends FieldValues>(props: FacultySelectControlProps<T>) {
  const { data, isLoading, isError, refetch } = useQuery(facultyOptions.getAll());
  const { t } = useTranslation();
  const [hasAddedNew, setHasAddedNew] = useState(false);

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={(data ?? []).map(j => ({ id: j.id, name: j.name }))}
      description={t('faculties.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('faculties.select.nothingFound')}</Text>
          {!hasAddedNew && (
            <Button
              size="xs"
              onClick={() => {
                window.open('/faculty/create');
                setHasAddedNew(true);
              }}
            >
              {t('button.add')}
            </Button>
          )}
          {hasAddedNew && <Button onClick={() => refetch()}>{t('button.refresh')}</Button>}
        </Stack>
      }
      {...props}
    />
  );
}
